const storefrontApiToken = 'c0739335af285ce3c0177f08b0c4275b';
const storefrontEndpoint = 'https://shopilargentousa.myshopify.com/api/2023-07/graphql.json';

const query = `
  query ($cursor: String) {
    products(first: 100, after: $cursor) {
      edges {
        node {
          vendor
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

let vendorsList = [];
let totalProducts = 10000;
let productsLoaded = 0;
let vendorsLoaded = false;
let progressInterval = null;

async function fetchVendors(cursor = null) {
  showLoader();

  // console.log('Fetching vendors with cursor:', cursor);

  const response = await fetch(storefrontEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontApiToken,
    },
    body: JSON.stringify({
      query: query,
      variables: { cursor },
    }),
  });

  const json = await response.json();

  if (json.errors) {
    console.error('Error fetching vendors:', json.errors);
    hideLoader();
    return;
  }

  const products = json.data.products.edges;

  products.forEach(product => {
    if (!vendorsList.includes(product.node.vendor)) {
      vendorsList.push(product.node.vendor);
    }
  });

  productsLoaded += products.length;

  const progress = Math.round((productsLoaded / totalProducts) * 100);

  updateLoaderProgress(progress);

  if (json.data.products.pageInfo.hasNextPage) {
    // console.log('More vendors to fetch, continuing...');
    await fetchVendors(json.data.products.pageInfo.endCursor);
  } else {
    console.log('All vendors fetched. Total vendors:', vendorsList.length);

    vendorsLoaded = true;

    if (progress < 100) {
      simulateProgressTo100(progress);
    } else {
      vendorsList.sort((a, b) => a.localeCompare(b));
      displayVendors(vendorsList);
      hideLoader();
    }
  }
}

// Simular la carga del 84% al 100%
function simulateProgressTo100(currentProgress) {
  if (progressInterval) return;

  progressInterval = setInterval(() => {
    if (currentProgress < 100) {
      currentProgress += 1;
      updateLoaderProgress(currentProgress);
    } else {
      clearInterval(progressInterval);
      vendorsList.sort((a, b) => a.localeCompare(b)); // Ordenar los vendors alfabéticamente
      displayVendors(vendorsList); // Mostrar los vendors
      hideLoader(); // Ocultar el loader
    }
  }, 100);
}


function displayVendors(vendorsList) {
  const vendorContainer = document.getElementById('vendor-list');

  if (vendorContainer) {
    // Inserta el párrafo al principio del contenedor
    vendorContainer.innerHTML = `<p>Discover and find your favorite brand among the <b>${vendorsList.length} brands</b> we offer.</p>`;

    // Crear un div que contenga todos los ul
    const ulContainer = document.createElement('div');
    ulContainer.classList.add('vendors-ul-container'); // Clase para estilos si es necesario

    let currentLetter = '';

    // Iterar sobre la lista de vendors
    vendorsList.forEach(vendor => {
      const firstLetter = vendor.charAt(0).toUpperCase();

      // Si la letra cambia, crea un nuevo ul para esa letra
      if (firstLetter !== currentLetter) {
        currentLetter = firstLetter;

        const ul = document.createElement('ul');
        ul.classList.add('vendor-list');

        const liHeader = document.createElement('li');
        liHeader.innerHTML = `<strong>${currentLetter}</strong>`;
        ul.appendChild(liHeader);

        ulContainer.appendChild(ul); // Agrega el ul al contenedor de ul
      }

      // Agrega cada vendor al ul actual
      const li = document.createElement('li');
      li.innerHTML = `<a href="/collections/vendors?q=${encodeURIComponent(vendor)}" target="_blank">${vendor}</a>`;

      ulContainer.lastElementChild.appendChild(li);
    });

    // Agrega el contenedor de ul al contenedor principal
    vendorContainer.appendChild(ulContainer);
  } else {
    console.error('Error: No se encontró el contenedor "vendor-list".');
  }
}


// Función para mostrar el loader
function showLoader() {
  const loader = document.getElementById('loader');
  if (loader) {
    loader.style.display = 'block';
  }
}

// Función para ocultar el loader
function hideLoader() {
  const loader = document.getElementById('loader');
  if (loader) {
    loader.style.display = 'none';
  }
}

// Función para actualizar el progreso del loader
function updateLoaderProgress(progress) {
  const progressBarBrand = document.getElementById('loader-progress__brands');
  if (progressBarBrand) {
    progressBarBrand.style.width = `${progress}%`;
  }
  const loaderText = document.getElementById('selector-progress__brands--text');
  if (loaderText) {
    loaderText.textContent = `${progress}%`;
  }

  const loaderMove = document.getElementById('selector-progress__brands');
  if (loaderMove) {
    loaderMove.style.left = `${progress}%`;
  }
}

// Iniciar la carga de vendors
fetchVendors();